import { VenuesModuleParameters } from 'features/home/types'
import { VENUES_FACETS_ENUM } from 'libs/algolia/enums/facetsEnums'
import {
  buildLocationParameter,
  BuildLocationParameterParams,
} from 'libs/algolia/fetchAlgolia/buildAlgoliaParameters/buildLocationParameter'
import { getActivityFacetFilters } from 'libs/algolia/fetchAlgolia/buildAlgoliaParameters/getActivityFacetFilters'
import { FiltersArray } from 'libs/algolia/types'

export const buildVenuesQueryOptions = (
  params: VenuesModuleParameters,
  buildLocationParameterParams: BuildLocationParameterParams
) => {
  const { tags = [], activities = [], hasVolunteering } = params

  const facetFilters: FiltersArray = []

  if (tags.length) {
    const tagsPredicate = buildTagsPredicate(tags)
    facetFilters.push(tagsPredicate)
  }

  if (activities.length) {
    const activitiesPredicate = buildActivitiesPredicate(activities.map(getActivityFacetFilters))
    facetFilters.push(activitiesPredicate)
  }

  if (hasVolunteering) {
    // Volunteering playlist is allowed to surface venues not open to public
    const hasVolunteeringPredicate = [`${VENUES_FACETS_ENUM.VENUE_HAS_VOLUNTEERING}:true`]
    facetFilters.push(hasVolunteeringPredicate)
  } else {
    const isOpenToPublicPredicate = [`${VENUES_FACETS_ENUM.VENUE_IS_OPEN_TO_PUBLIC}:true`]
    facetFilters.push(isOpenToPublicPredicate)
  }

  return {
    ...buildLocationParameter(buildLocationParameterParams),
    ...(facetFilters.length > 0 ? { facetFilters } : {}),
  }
}

export const buildActivitiesPredicate = (activities: string[]): string[] =>
  activities.map((activity) => `${VENUES_FACETS_ENUM.ACTIVITY}:${activity}`)

const buildTagsPredicate = (tags: string[]): string[] =>
  tags.map((tag: string) => `${VENUES_FACETS_ENUM.TAGS}:${tag}`)
